<div class="layoutBlock">
    <div class="entrypageSideLeft"></div>

    <div class="entrypageCenter">
        <form [formGroup]="attributeSelectForm" >
            <input type="text" [(ngModel)]="selectedProcessType" formControlName="processTypeFC"> (Vorgangsart)
            <br>
            <input type="text" [(ngModel)]="selectedProcessId" formControlName="processIdFC"> (VorgangsId)
            <br>
            <button type="button" (click)="load()">Laden</button>
            <hr>
        </form>

        <erp-workflow-history [processType]="'sas'" [processId]="340"></erp-workflow-history>
    </div>

    <div class="entrypageSideRight"></div>
</div>
